<template>
  <a-card :bordered="false">
    <div class="salesCard">
      <a-tabs default-active-key="1" @change="changeTabs" size="large" :tab-bar-style="{marginBottom: '24px', paddingLeft: '16px'}">
        <a-tab-pane loading="true" tab="待审核" key="1">
            <!-- 查询区域 -->
            <div class="table-page-search-wrapper">
              <a-form layout="inline" @keyup.enter.native="searchQuery">
                <a-row :gutter="24">
                  <a-col :md="6" :sm="12">
                    <a-form-item label="账号">
                      <a-input placeholder="请输入账号" v-model="queryParam.username"></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="12">
                    <a-form-item label="手机号码">
                      <a-input placeholder="请输入手机号码" v-model="queryParam.phone"></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="12">
                    <a-form-item label="用户姓名">
                      <a-input placeholder="请输入用户姓名" v-model="queryParam.realname"></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="12">
                    <a-form-item label="申请使用应用">
                      <a-select v-model="queryParam.selectedApplications" allowClear >
                        <a-select-option v-for="(item,index) in applicationOptions" :key="index" :value="item.id" >
                          {{ item.applicationName }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="12">
                  <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                    <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                    <a-button type="primary" @click="searchResetCustom(queryParam)" icon="reload" style="margin-left: 8px">重置</a-button>
                  </span>
                  </a-col>
                </a-row>
              </a-form>
            </div>

            <!-- 操作按钮区域 -->
            <div class="table-operator" style="border-top: 5px">
              <a-dropdown v-if="selectedRowKeys.length > 0">
                <a-menu slot="overlay" @click="handleMenuClick">
                  <a-menu-item key="1">
                    <a-icon type="delete" @click="batchDel"/>
                    删除
                  </a-menu-item>
                </a-menu>
                <a-button style="margin-left: 8px">
                  批量操作
                  <a-icon type="down"/>
                </a-button>
              </a-dropdown>
            </div>

            <!-- table区域-begin -->
            <div>
              <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
                <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;<a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项&nbsp;&nbsp;
                <a style="margin-left: 24px" @click="onClearSelected">清空</a>
              </div>

              <a-table
                ref="table"
                bordered
                size="middle"
                rowKey="id"
                :columns="columns"
                :dataSource="dataSource"
                :pagination="ipagination"
                :loading="loading"
                :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
                @change="handleTableChange">

                <template slot="avatarslot" slot-scope="text, record, index">
                  <div class="anty-img-wrap">
                    <a-avatar shape="square" :src="getAvatarView(record.avatar)" icon="user"/>
                  </div>
                </template>

                <span slot="action" slot-scope="text, record">
                  <a @click="handleDetail(record)">审核</a>
                  <a-divider type="vertical" />
                  <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                    <a>删除</a>
                  </a-popconfirm>
                </span>
            </a-table>
          </div>
            <!-- table区域-end -->
        </a-tab-pane>

        <a-tab-pane tab="已审核" key="2">
          <!-- 查询区域 -->
          <div class="table-page-search-wrapper">
            <a-form layout="inline" @keyup.enter.native="searchQuery">
              <a-row :gutter="24">
                <!--<a-col :md="6" :sm="12">
                  <a-form-item label="审核状态">
                    <a-radio-group v-model="queryParam.auditStatus">
                      <a-radio value="approved_search">已通过</a-radio>
                      <a-radio value="rejected_search">已拒绝</a-radio>
                    </a-radio-group>
                  </a-form-item>
                </a-col>-->
                <a-col :md="6" :sm="12">
                  <a-form-item label="账号">
                    <a-input placeholder="请输入账号" v-model="queryParam.usernameApproved"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="12">
                  <a-form-item label="手机号码">
                    <a-input placeholder="请输入手机号码" v-model="queryParam.phoneApproved"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="12">
                  <a-form-item label="用户姓名">
                    <a-input placeholder="请输入用户姓名" v-model="queryParam.realnameApproved"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="12">
                  <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                    <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                    <a-button type="primary" @click="searchResetCustom(queryParam)" icon="reload" style="margin-left: 8px">重置</a-button>
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>

          <!-- 操作按钮区域 -->
          <div class="table-operator" style="border-top: 5px">
            <a-dropdown v-if="selectedRowKeys.length > 0">
              <a-menu slot="overlay" @click="handleMenuClick">
                <a-menu-item key="1">
                  <a-icon type="delete" @click="batchDel"/>
                  删除
                </a-menu-item>
              </a-menu>
              <a-button style="margin-left: 8px">
                批量操作
                <a-icon type="down"/>
              </a-button>
            </a-dropdown>
          </div>

          <!-- table区域-begin -->
          <div>
            <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
              <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;<a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项&nbsp;&nbsp;
              <a style="margin-left: 24px" @click="onClearSelected">清空</a>
            </div>

            <a-table
              ref="table"
              bordered
              size="middle"
              rowKey="id"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="ipagination"
              :loading="loading"
              :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
              @change="handleTableChange">

              <template slot="avatarslot" slot-scope="text, record, index">
                <div class="anty-img-wrap">
                  <a-avatar shape="square" :src="getAvatarView(record.avatar)" icon="user"/>
                </div>
              </template>

              <span slot="action" slot-scope="text, record">
                  <a @click="handleDetail(record)">详情</a>
                  <a-divider type="vertical" />
                  <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                    <a>删除</a>
                  </a-popconfirm>
                </span>
            </a-table>
          </div>
          <!-- table区域-end -->
        </a-tab-pane>
      </a-tabs>
    </div>

    <user-apply-audit-modal ref="modalForm" @ok="modalFormOk" :auditFlag="auditFlag"></user-apply-audit-modal>

    <password-modal ref="passwordmodal" @ok="passwordModalOk"></password-modal>

  </a-card>
</template>

<script>
  import UserApplyAuditModal from './modules/UserApplyAuditModal'
  import PasswordModal from './modules/PasswordModal'
  import {putAction,getFileAccessHttpUrl} from '@/api/manage';
  import { frozenBatch,duplicateCheck,applicationList } from '@/api/api'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import SysUserAgentModal from "./modules/SysUserAgentModal";
  import JInput from '@/components/jeecg/JInput'
  import UserRecycleBinModal from './modules/UserRecycleBinModal'
  import JSuperQuery from '@/components/jeecg/JSuperQuery'
  import JThirdAppButton from '@/components/jeecgbiz/thirdApp/JThirdAppButton'

  export default {
    name: "UserApplyAuditList",
    mixins: [JeecgListMixin],
    components: {
      UserApplyAuditModal,
      JThirdAppButton,
      SysUserAgentModal,
      PasswordModal,
      JInput,
      UserRecycleBinModal,
      JSuperQuery
    },
    data() {
      return {
        uploadSource:"platform",
        applicationOptions:[],
        selectedApplications:'',
        auditFlag: false,
        description: '这是用户管理页面',
        queryParam: {
          auditStatus: 'approving'
        },
        recycleBinVisible: false,
        columns: [
          /*{
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },*/
          {
            title: '用户账号',
            align: "center",
            dataIndex: 'username',
            width: 120,
            sorter: true
          },
          {
            title: '用户姓名',
            align: "center",
            width: 100,
            dataIndex: 'realname',
          },
          {
            title: '头像',
            align: "center",
            width: 120,
            dataIndex: 'avatar',
            scopedSlots: {customRender: "avatarslot"}
          },

          {
            title: '性别',
            align: "center",
            width: 80,
            dataIndex: 'sex_dictText',
            sorter: true
          },
          {
            title: '生日',
            align: "center",
            width: 100,
            dataIndex: 'birthday'
          },
          {
            title: '手机号码',
            align: "center",
            width: 100,
            dataIndex: 'phone'
          },
          {
            title: '部门',
            align: "center",
            width: 180,
            dataIndex: 'orgCodeTxt',
            ellipsis: true,
          },
          {
            title: '审核状态',
            align: "center",
            width: 80,
            dataIndex: 'auditStatus_dictText'
          },
          {
            title: '操作',
            dataIndex: 'action',
            scopedSlots: {customRender: 'action'},
            align: "center",
            width: 170
          }

        ],
        superQueryFieldList: [
          { type: 'input', value: 'username', text: '用户账号', },
          { type: 'input', value: 'realname', text: '用户姓名', },
          { type: 'select', value: 'sex', dbType: 'int', text: '性别', dictCode: 'sex' },
        ],
        url: {
          syncUser: "/act/process/extActProcess/doSyncUser",
          list: "/sys/sysUserApplyAudit/list",
          delete: "/sys/sysUserApplyAudit/delete",
          deleteBatch: "/sys/sysUserApplyAudit/deleteBatch",
          exportXlsUrl: "/sys/sysUserApplyAudit/exportXls",
          importExcelUrl: "sys/sysUserApplyAudit/importExcel",
        },
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    created() {
      this.initApplicationList();
    },
    methods: {
      getAvatarView: function (avatar) {
        return getFileAccessHttpUrl(avatar,this.uploadSource)
      },
      searchResetCustom(params) {
        if(params.auditStatus=='approving'){
          this.queryParam.username = null;
          this.queryParam.realname = null;
          this.queryParam.phone = null;
        } else if (params.auditStatus=='approved'){
          this.queryParam.usernameApproved = null;
          this.queryParam.realnameApproved = null;
          this.queryParam.phoneApproved = null;
        }
        this.loadData(1);
      },
      changeTabs(key){
        if(key == "1"){
          this.auditFlag = false;
          this.queryParam.auditStatus = 'approving';
        } else {
          this.auditFlag = true;
          this.queryParam.auditStatus = 'approved';
        }
        this.searchQuery();
      },
      batchFrozen: function (status) {
        if (this.selectedRowKeys.length <= 0) {
          this.$message.warning('请选择一条记录！');
          return false;
        } else {
          let ids = "";
          let that = this;
          let isAdmin = false;
          that.selectionRows.forEach(function (row) {
            if (row.username == 'admin') {
              isAdmin = true;
            }
          });
          if (isAdmin) {
            that.$message.warning('管理员账号不允许此操作,请重新选择！');
            return;
          }
          that.selectedRowKeys.forEach(function (val) {
            ids += val + ",";
          });
          that.$confirm({
            title: "确认操作",
            content: "是否" + (status == 1 ? "解冻" : "冻结") + "选中账号?",
            onOk: function () {
              frozenBatch({ids: ids, status: status}).then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.loadData();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              });
            }
          });
        }
      },
      handleMenuClick(e) {
        if (e.key == 1) {
          this.batchDel();
        } else if (e.key == 2) {
          this.batchFrozen(2);
        } else if (e.key == 3) {
          this.batchFrozen(1);
        }
      },
      handleFrozen: function (id, status, username) {
        let that = this;
        //TODO 后台校验管理员角色
        if ('admin' == username) {
          that.$message.warning('管理员账号不允许此操作！');
          return;
        }
        frozenBatch({ids: id, status: status}).then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            that.loadData();
          } else {
            that.$message.warning(res.message);
          }
        });
      },
      handleChangePassword(username) {
        this.$refs.passwordmodal.show(username);
      },
      handleAgentSettings(username){
        this.$refs.sysUserAgentModal.agentSettings(username);
        this.$refs.sysUserAgentModal.title = "用户代理人设置";
      },
      passwordModalOk() {
        //TODO 密码修改完成 不需要刷新页面，可以把datasource中的数据更新一下
      },
      onSyncFinally({isToLocal}) {
        // 同步到本地时刷新下数据
        if (isToLocal) {
          this.loadData()
        }
      },
      initApplicationList(){
        let that = this;
        applicationList().then((res) => {
          if(res.success){
            /*this.applicationOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.applicationName, value:item.id}
              return c;
            })*/
            that.applicationOptions = res.result;
            console.log('this.applicationOptions: ',this.applicationOptions)
          }
        })
      },
    }

  }
</script>
<style scoped>
  @import '~@assets/less/common.less'
</style>